
import { supabase } from "@/integrations/supabase/client";
import { AgentDiscoveryData } from "./types";

export const AgentDiscoveryService = {
  async getDiscoveryData(): Promise<AgentDiscoveryData> {
    try {
      // Fetch trending agents (most downloaded)
      const { data: trendingAgents, error: trendingError } = await supabase
        .from("agents")
        .select("id, name, description, downloads")
        .order("downloads", { ascending: false })
        .limit(10);
        
      if (trendingError) throw trendingError;
      
      // Fetch new agents (recently created)
      const { data: newAgents, error: newError } = await supabase
        .from("agents")
        .select("id, name, description, created_at")
        .order("created_at", { ascending: false })
        .limit(10);
        
      if (newError) throw newError;
        
      // Map the results to the expected format
      const formattedTrendingAgents = trendingAgents.map(agent => ({
        id: agent.id,
        name: agent.name,
        description: agent.description,
        downloads: agent.downloads || 0,
        rating: 0 // Default rating since we don't have it in the database yet
      }));
      
      const formattedNewAgents = newAgents.map(agent => ({
        id: agent.id,
        name: agent.name,
        description: agent.description,
        createdAt: new Date(agent.created_at)
      }));
        
      return {
        trendingAgents: formattedTrendingAgents,
        newAgents: formattedNewAgents
      };
    } catch (error) {
      console.error("Error fetching discovery data:", error);
      return { trendingAgents: [], newAgents: [] };
    }
  }
};
